// Makes every Vuetify dialog in the app movable by dragging its header, without touching each
// dialog component. A single capture-phase mousedown listener detects a press on a dialog's title
// (`.v-card__title`) or header toolbar (a `.v-toolbar` that is a direct child of the dialog's card)
// and then translates the `.v-dialog` element as the pointer moves. Buttons/inputs in the header,
// the actions toolbar, and fullscreen dialogs are excluded.

const INTERACTIVE = 'button, a, input, textarea, select, label, .v-input, .v-btn, [role="button"], [contenteditable]';

let dragging = false;
let dialogEl = null;
let startX = 0, startY = 0, baseX = 0, baseY = 0;
let homeLeft = 0, homeTop = 0, elWidth = 0, elHeight = 0;

function currentTranslate(el) {
    const m = /translate\(\s*(-?\d+(?:\.\d+)?)px\s*,\s*(-?\d+(?:\.\d+)?)px\s*\)/.exec(el.style.transform || '');
    return m ? { x: parseFloat(m[1]), y: parseFloat(m[2]) } : { x: 0, y: 0 };
}

// The drag handle is the dialog's own header: the title, or a toolbar that is a direct child of the
// dialog's top-level card (which excludes the actions toolbar, wrapped in its own container).
function findHandle(target, dialogEl) {
    const handle = target.closest('.v-card__title, .v-toolbar');
    if (!handle) return null;
    const card = handle.closest('.v-card');
    if (!card || card.parentElement !== dialogEl) return null; // only the dialog's top card
    if (handle.parentElement !== card) return null;            // header title/toolbar only
    return handle;
}

function onMouseDown(e) {
    if (e.button !== 0) return;

    const dlg = e.target.closest('.v-dialog');
    if (!dlg || dlg.classList.contains('v-dialog--fullscreen')) return;

    const handle = findHandle(e.target, dlg);
    if (!handle) return;

    // Let controls in the header (close buttons, etc.) work normally.
    if (e.target.closest(INTERACTIVE)) return;

    dialogEl = dlg;
    const t = currentTranslate(dlg);
    baseX = t.x; baseY = t.y;
    startX = e.clientX; startY = e.clientY;

    const rect = dlg.getBoundingClientRect();
    homeLeft = rect.left - baseX;
    homeTop = rect.top - baseY;
    elWidth = rect.width;
    elHeight = rect.height;

    dragging = true;
    document.addEventListener('mousemove', onMouseMove, true);
    document.addEventListener('mouseup', onMouseUp, true);
    document.body.style.userSelect = 'none';
    e.preventDefault();
}

function onMouseMove(e) {
    if (!dragging || !dialogEl) return;

    let x = baseX + (e.clientX - startX);
    let y = baseY + (e.clientY - startY);

    // Keep the dialog reachable: don't let it be dragged fully off-screen.
    let left = homeLeft + x;
    let top = homeTop + y;
    const margin = 120;
    top = Math.max(8, Math.min(top, window.innerHeight - 40));
    left = Math.max(margin - elWidth, Math.min(left, window.innerWidth - margin));
    x = left - homeLeft;
    y = top - homeTop;

    dialogEl.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
}

function onMouseUp() {
    dragging = false;
    dialogEl = null;
    document.removeEventListener('mousemove', onMouseMove, true);
    document.removeEventListener('mouseup', onMouseUp, true);
    document.body.style.userSelect = '';
}

function injectCursorStyle() {
    if (document.getElementById('webcy-draggable-dialog-style')) return;
    const style = document.createElement('style');
    style.id = 'webcy-draggable-dialog-style';
    style.textContent =
        '.v-dialog:not(.v-dialog--fullscreen) > .v-card > .v-card__title,' +
        '.v-dialog:not(.v-dialog--fullscreen) > .v-card > .v-toolbar { cursor: move; }';
    document.head.appendChild(style);
}

injectCursorStyle();
document.addEventListener('mousedown', onMouseDown, true);
